import { combineReducers } from 'redux';

import {
  INVENTORY_SUMMARY_SET_ITEMS,
  INVENTORY_SUMMARY_SET_TOTAL_PAGE,
  INVENTORY_SUMMARY_SET_CURRENT_PAGE,
  INVENTORY_SUMMARY_SET_OUTLETS,
  INVENTORY_SUMMARY_SET_ROW_ITEMS,
  INVENTORY_SUMMARY_SET_INGREDIENTS,
  INVENTORY_SUMMARY_EXPORT_START,
  INVENTORY_SUMMARY_EXPORT_DONE,
  INVENTORY_SUMMARY_SET_ASYNCJOBID,
} from '../../actions/inventory/summary/constants';
import createReducer from '../../utils/createReducer';

const currentPage = createReducer(null, {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [INVENTORY_SUMMARY_SET_CURRENT_PAGE]: (draft, { payload }) => payload.page,
});

const idAsyncJob = createReducer(null, {
  [INVENTORY_SUMMARY_SET_ASYNCJOBID]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.idAsyncJob,
});

const ingredients = createReducer([], {
  [INVENTORY_SUMMARY_SET_INGREDIENTS]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.ingredients,
});

const isExportLoading = createReducer(false, {
  [INVENTORY_SUMMARY_EXPORT_START]: () => true,
  [INVENTORY_SUMMARY_EXPORT_DONE]: () => false,
});

const items = createReducer([], {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [INVENTORY_SUMMARY_SET_ITEMS]: (draft, { payload }) => payload.items,
});

const outlets = createReducer([], {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [INVENTORY_SUMMARY_SET_OUTLETS]: (draft, { payload }) => payload.outlets,
});

const rowItems = createReducer([], {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [INVENTORY_SUMMARY_SET_ROW_ITEMS]: (draft, { payload }) => payload.items,
});

const totalPage = createReducer(null, {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [INVENTORY_SUMMARY_SET_TOTAL_PAGE]: (draft, { payload }) => payload.page,
});

export default combineReducers({
  currentPage,
  idAsyncJob,
  ingredients,
  isExportLoading,
  items,
  outlets,
  rowItems,
  totalPage,
});
